import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import {
    Container,
    Content2Xl,
    ContentWithVerticalPadding,
} from "components/misc/Layouts";
import tw from "twin.macro";
//import styled from "styled-components";
//import { LogoLink } from "components/headers/light.js";
import { SectionHeading as HeadingBase } from "components/misc/Headings";
import { SectionDescription as DescriptionBase } from "components/misc/Typography";
import Header from "components/headers/light.js";

//import { ReactComponent as CheckboxIcon } from "feather-icons/dist/icons/check-circle.svg";
import GoogleDownloadImageSrc from "images/GetItOnGooglePlay_English.png";
import AppleDownloadImageSrc from "images/Download_on_the_App_Store_US.svg";
//import heatScreenshotImageSrc from "images/demo/MainLandingPageHero.png";
import BaseballImageSrc from "images/demo/baseballGOAT.png";
//import logo from "images/gslogo.png";
//import ResponsiveVideoEmbed from "./helpers/ResponsiveVideoEmbed.js";

import Footer from "components/footers/FiveColumnWithInputForm.js";


const Image = tw.img`max-w-full rounded-t sm:rounded`;

const SectionContainer = tw(ContentWithVerticalPadding)``;
const SectionHeading = tw(HeadingBase)`text-primary-900`;
const SectionDescription = tw(
    DescriptionBase
)`text-center mx-auto text-gray-600 max-w-4xl`;



export default ({
    features = null,
    
    heading = "Welcome to the wonderful world of sports games!",
    description = "Every member of our team is driven by a love for sports and a dedication to game development. We are committed not only to creating realistic and exciting gaming environments but also to fostering a positive, vibrant community to share the charm and joy of sports with you.",
}) => {
    

    features =
        features ||
        [
            
        ];

    return (
        <AnimationRevealPage disabled>
            <Header />
            <Container tw="bg-gray-100 -mx-8 -mt-8 pt-8 px-8">
                <Content2Xl>
                    
                    <SectionContainer id="landingPageDemos">
                        <SectionHeading>Baseball GOAT
                        </SectionHeading>
                        <SectionDescription>
                            Welcome to our baseball world! In this thrilling game, you'll step into the shoes of a professional baseball player and experience the excitement of real-life matches and intense showdowns. Whether you're a rookie or a seasoned player, there's something here for everyone. Train to improve your skills, build your dream team, and challenge top teams from around the globe to claim championship glory. Join us now and feel the magic of baseball!
                            <br />
                            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Baseball GOAT Privacy Policy</a>
                        </SectionDescription>
                        <br />
                        <Image src={BaseballImageSrc} />
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <a href="https://play.google.com/store/apps/details?id=com.redfalcon.baseballgoat.android" target="_blank" rel="noopener noreferrer">
                                <Image src={GoogleDownloadImageSrc} alt="Download on Google Play" style={{ width: '200px', margin: '10px' }} />
                            </a>
                            <a href="https://apps.apple.com/us/app/baseball-goat/id6677019784" target="_blank" rel="noopener noreferrer">
                                <Image src={AppleDownloadImageSrc} alt="Download on Google Play" style={{ width: '200px', margin: '6px' }} />
                            </a>
                        </div>
                    </SectionContainer>
                    <div className="App">
                        <Footer />
                    </div>
                </Content2Xl>
            </Container>
        </AnimationRevealPage>
    );
};
